import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import useMissionStore from '../store/cmsStore/missionStore';
import Seo from '../components/Seo';


const Mission: React.FC = () => {
  const { sections, fetchMissionContent } = useMissionStore();

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchMissionContent();
  }, [fetchMissionContent]);

  return (
    <>
        <Seo
          title="Our Mission | Connecting Hearts, Transforming Lives"
          description="SLAMMMM exists to help singles ditch the swipe fatigue and meet real people in real life. Learn about our mission to bring dating back to basics."
        />
  {sections.mission_hero_section && ( 
    <section className="hero_section_inner position-relative bg-light pt-4">
        <div className="container">
            <div className="row">
                <div className="col-md-5">
                    <div className="hero_caption">
                    <h1 
                      className="text-dark" 
                      dangerouslySetInnerHTML={{ __html: sections.mission_hero_section.payload.field_1.value }}
                    ></h1>
                          <Link to={sections.mission_hero_section.payload.field_2.link || '#'}><button className="btn btn-primary">{sections.mission_hero_section.payload.field_2.value}</button></Link>  
                    </div>
                </div>
                <div className="col-md-7">
                    <div className="hero_section_inner_img" style={{ backgroundImage: `url(${sections.mission_hero_section.payload.field_3.value})`}}>

                    </div>
                </div>
            </div>
        </div>
    </section>
    )}
{sections.our_story && ( 
    <section className="py-100 our_story_section">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 pe-lg-85">
                    <div className="section_title mb-4">
                        <p className="text-primary">{sections.our_story.payload.field_1.value}</p>
                        <h2 className="mb-4">{sections.our_story.payload.field_2.value}</h2>
                    </div>
                    <div 
                      dangerouslySetInnerHTML={{ __html: sections.our_story.payload.field_3.value }} 
                      />
                  
                </div>
                <div className="col-lg-6">
                    <div className="img_cover_wrapper">
                        <img src={sections.our_story.payload.field_4.value} className="img-fluid" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </section>
    )}

{sections.our_values && ( 
    <section className="py-100 our_values_section bg-light">
        <div className="container">
            <div className="row">
                <div className="col-lg-4 pe-lg-85">
                    <div className="section_title mb-4">
                        <p className="text-primary">{sections.our_values.payload.field_1.value}</p>
                        <h2 className="mb-4">{sections.our_values.payload.field_2.value}</h2>
                    </div>
                    <p className="font20 mb-3">{sections.our_values.payload.field_3.value}
                    </p>

                </div>
                <div className="col-lg-8">
                    <div className="row g-4">
                        <div className="col-md-6">
                            <div className="card  h-100">
                                <div className="d-flex justify-content-between  align-items-center border-bottom mb-3 pb-2">
                                    <h3 className="font30 mb-0">{sections.our_values.payload.field_4.value}</h3>
                                        <p className="font30 mb-0 text-primary opacity-50">01</p>
                                </div>
                                <p className="mb-0 font20">
                                {sections.our_values.payload.field_5.value}
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card  h-100">
                                <div className="d-flex justify-content-between  align-items-center border-bottom mb-3 pb-2">
                                    <h3 className="font30 mb-0">{sections.our_values.payload.field_6.value}</h3>
                                        <p className="font30 mb-0 text-primary opacity-50">02</p>
                                </div>
                                <p className="mb-0 font20">
                                {sections.our_values.payload.field_7.value}
                                    
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card  h-100">
                                <div className="d-flex justify-content-between  align-items-center border-bottom mb-3 pb-2">
                                    <h3 className="font30 mb-0">{sections.our_values.payload.field_8.value}</h3>
                                        <p className="font30 mb-0 text-primary opacity-50">03</p>
                                </div>
                                <p className="mb-0 font20">{sections.our_values.payload.field_9.value}
                                   
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card h-100">
                                <div className="d-flex justify-content-between  align-items-center border-bottom mb-3 pb-2">
                                    <h3 className="font30 mb-0">{sections.our_values.payload.field_10.value}</h3>
                                        <p className="font30 mb-0 text-primary opacity-50">04</p>
                                </div>
                                <p className="mb-0 font20">
                                  {sections.our_values.payload.field_11.value}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
      )}


{sections.start_your_love_journey && ( 
    <section className="py-100 love_journey_section" style={{ backgroundImage: `url(${sections.start_your_love_journey.payload.field_1.value})`}}>
        <div className="container">
            <div className="row">
                <div className="offset-lg-5 col-lg-7 ps-5 z-3 position-relative">
                    <div className="section_title mb-3">
                        <h2 className="text-white">{sections.start_your_love_journey.payload.field_2.value}</h2>
                    </div>
                    <p className="text-white font20 mb-4 pb-2">{sections.start_your_love_journey.payload.field_3.value}
                    </p>
                    <Link to={sections.start_your_love_journey.payload.field_4.link || '#'}><button className="btn btn-primary">{sections.start_your_love_journey.payload.field_4.value}</button></Link>
                </div>
            </div>
        </div>
    </section>
    )}
{sections.our_principles && ( 
    <section className="py-100 our_values_section bg-light">
        <div className="container">
            <div className="border-bottom pb-5">
                <div className="row ">
                    <div className="col-lg-5">
                        <div className="section_title">
                            <p className="text-primary">{sections.our_principles.payload.field_1.value}</p>
                            <h2 className="mb-0">{sections.our_principles.payload.field_2.value}</h2>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <p className="font20 mb-0">{sections.our_principles.payload.field_3.value}
                        </p>
                    </div>
                </div>
            </div>

            <div className="row g-4 mt-4">
                <div className="col-md-4">
                    <div className="card  h-100">
                        <div className="d-flex justify-content-between  align-items-center border-bottom mb-3 pb-2">
                            <h3 className="font28 mb-0 text-primary">{sections.our_principles.payload.field_4.value}</h3>
                                <p className="font28 mb-0 text-secondary opacity-50">01</p>
                        </div>
                        <p className="mb-0 font20">{sections.our_principles.payload.field_5.value}
                            
                        </p>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card  h-100">
                        <div className="d-flex justify-content-between  align-items-center border-bottom mb-3 pb-2">
                            <h3 className="font28 mb-0 text-primary">{sections.our_principles.payload.field_6.value}</h3>
                                <p className=" font28 mb-0 text-secondary  opacity-50">02</p>
                        </div>
                        <p className="mb-0 font20">
                        {sections.our_principles.payload.field_7.value}
                        </p>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card  h-100">
                        <div className="d-flex justify-content-between  align-items-center border-bottom mb-3 pb-2">
                            <h3 className="font28 mb-0 text-primary">{sections.our_principles.payload.field_8.value}</h3>
                                <p className=" font28 mb-0 text-secondary  opacity-50">03</p>
                        </div>
                        <p className="mb-0 font20">
                            {sections.our_principles.payload.field_9.value}
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </section>
    )}

    {sections.our_approach && ( 
    <section className="py-100 our_approach_section">
            <div className="container">
                <div className="border-bottom pb-5 mb-4">
                    <div className="row align-items-center">
                        <div className="col-lg-5">
                            <div className="section_title">
                                <p className="text-primary">{sections.our_approach.payload.field_1.value.replace('Approcach', 'Approach')}</p>
                                <h2 className="mb-0">{sections.our_approach.payload.field_2.value}</h2>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <p className="font20 mb-0">{sections.our_approach.payload.field_3.value}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row  gx-5">
                    <div className="col-lg-6">
                        <div className="my-4">
                            <h3 className="font28 mb-3 pb-3 border-bottom">{sections.our_approach.payload.field_4.value}
                            </h3>
                            <p className="mb-0 font20">{sections.our_approach.payload.field_5.value}
                                
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="my-4">
                            <h3 className="font28 mb-3 pb-3 border-bottom">{sections.our_approach.payload.field_6.value}
                            </h3>
                            <p className="mb-0 font20">
                            {sections.our_approach.payload.field_7.value}
                                
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="my-4">
                            <h3 className="font28 mb-3 pb-3 border-bottom">{sections.our_approach.payload.field_8.value}
                            </h3>
                            <p className="mb-0 font20">
                            {sections.our_approach.payload.field_9.value}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="my-4">
                            <h3 className="font28 mb-3 pb-3 border-bottom">{sections.our_approach.payload.field_10.value}
                            </h3>
                            <p className="mb-0 font20">
                            {sections.our_approach.payload.field_11.value}
                            </p>
                        </div>
                    </div>

                </div>
                <Link to={sections.our_approach.payload.field_12.link || '#'}><button className="btn btn-outline-primary mt-xl-5 mt-sm-4">{sections.our_approach.payload.field_12.value}</button></Link>
            </div>
        </section>
    )}
    </>
  );
};

export default Mission;
